import {AiFillLinkedin} from 'react-icons/ai'
import {AiFillGithub} from 'react-icons/ai'
import {AiOutlineTwitter} from 'react-icons/ai'

export const links = [
    {id: 1, link: '#', title: 'Home'},
    {id: 2, link: '#about', title: 'About'},
    {id: 3, link: '#services', title: 'Services'},
    {id: 4, link: '#portfolio', title: 'Portfolio'},
    {id: 5, link: '#contact', title: 'Contact'}
]


export const socials = [
  {
    id: 1,
    link: "https://www.linkedin.com/in/subhashis-nath-a6a2a624",
    icon: <AiFillLinkedin />,
  },
  { 
    id: 2,
    link: "https://github.com/subha81788",
    icon: <AiFillGithub />,
  },
  {
    id: 3,
    link: "https://twitter.com/SubhashisN88",
    icon: <AiOutlineTwitter />,
  },
];